(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-sidebar-tags"] && !Shopify.designMode) return;
  try {
    class BlogCategoriesList extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';
    this.#loadCategories();
  }

  async #loadCategories() {
    const list = this.querySelector('[data-blog-categories-target]');
    if (!list) return;

    try {
      const blogs = await this.#fetchBlogs();
      const hidden = this.#hiddenValues();
      const visible = blogs.filter((blog) => {
        const title = blog.title.toLowerCase();
        const handle = blog.handle.toLowerCase();
        return !hidden.includes(title) && !hidden.includes(handle);
      });

      if (!visible.length) {
        this.closest('.blog-post-sidebar-block')?.remove();
        return;
      }

      list.replaceChildren(
        ...visible.map((blog) => {
          const li = document.createElement('li');
          li.className = 'blog-post-sidebar-tags__item';

          const a = document.createElement('a');
          a.className = 'blog-post-sidebar-tags__link';
          a.href = blog.url;
          a.textContent = blog.title;

          li.appendChild(a);
          return li;
        })
      );
    } catch (error) {
      console.error('[blog-categories-list]', error);
      this.closest('.blog-post-sidebar-block')?.remove();
    }
  }

  #hiddenValues() {
    return (this.dataset.hidden || '')
      .split(',')
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean);
  }

  async #fetchBlogs() {
    const sitemapRes = await fetch('/sitemap.xml', { credentials: 'same-origin' });
    if (!sitemapRes.ok) throw new Error('Failed to load sitemap');

    const sitemapXml = await sitemapRes.text();
    const blogSitemapUrls = [...sitemapXml.matchAll(/<loc>([^<]*sitemap_blogs[^<]*)<\/loc>/gi)].map(
      (match) => match[1].trim()
    );

    const sitemapUrls = blogSitemapUrls.length ? blogSitemapUrls : ['/sitemap_blogs_1.xml'];
    const handles = new Set();

    for (const sitemapUrl of sitemapUrls) {
      const res = await fetch(sitemapUrl, { credentials: 'same-origin' });
      if (!res.ok) continue;

      const xml = await res.text();
      for (const match of xml.matchAll(/\/blogs\/([^/<'"?#]+)/gi)) {
        const handle = decodeURIComponent(match[1]).trim();
        if (handle) handles.add(handle);
      }
    }

    const blogs = await Promise.all(
      [...handles].map(async (handle) => {
        const title = await this.#fetchBlogTitle(handle);
        return {
          handle,
          title,
          url: `/blogs/${handle}`,
        };
      })
    );

    return blogs.sort((a, b) => a.title.localeCompare(b.title));
  }

  async #fetchBlogTitle(handle) {
    try {
      const res = await fetch(`/blogs/${handle}.atom`, { credentials: 'same-origin' });
      if (!res.ok) return this.#titleize(handle);

      const atom = await res.text();
      const match = atom.match(/<title[^>]*>([^<]+)<\/title>/i);
      if (!match?.[1]) return this.#titleize(handle);

      return this.#decodeEntities(match[1].trim()) || this.#titleize(handle);
    } catch {
      return this.#titleize(handle);
    }
  }

  #titleize(handle) {
    return handle
      .split('-')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }

  #decodeEntities(value) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }
}

if (!customElements.get('blog-categories-list')) {
  customElements.define('blog-categories-list', BlogCategoriesList);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["blog-tag-article-count"] && !Shopify.designMode) return;
  try {
    (() => {
    const nodes = document.querySelectorAll('[data-blog-tag-count][data-count-url]');
    if (!nodes.length) return;

    nodes.forEach(async (node) => {
      const url = node.getAttribute('data-count-url');
      if (!url) return;

      try {
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) return;

        const raw = (await response.text()).trim();
        const count = Number.parseInt(raw, 10);
        if (Number.isNaN(count)) return;

        const suffix = node.getAttribute('data-suffix') || 'plans';
        const singular = node.getAttribute('data-singular-suffix') || 'plan';
        const label = `${count} ${count === 1 ? singular : suffix}`;
        const target = node.querySelector('.text-block p, .text-block');
        if (target) {
          if (target.tagName === 'P') {
            target.textContent = label;
          } else {
            const paragraph = target.querySelector('p');
            if (paragraph) paragraph.textContent = label;
            else target.textContent = label;
          }
        }
      } catch (error) {
        // Keep Liquid fallback count.
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["installments"] && !Shopify.designMode) return;
  try {
    /**
   * "Check Pre-Qualification" → open native Shop Pay installments modal
   * (same flow as "View sample plans" / purchasing power CTA).
   */
  async function openShopPayPrequalFromAnchor(anchor) {
    const scope = anchor.closest('.financing-options') || document;
    let terms =
      scope.querySelector('.installments-block shopify-payment-terms') ||
      scope.querySelector('shopify-payment-terms') ||
      document.querySelector('shopify-payment-terms');

    if (!terms) return false;

    await customElements.whenDefined('shopify-payment-terms');

    for (let attempt = 0; attempt < 20; attempt++) {
      const root = terms.shadowRoot;
      const cta =
        root?.querySelector('#shopify-installments-cta') ||
        root?.querySelector('.shopify-installments__button') ||
        root?.querySelector('[href*="installments"]');

      if (cta) {
        cta.click();
        return true;
      }

      await new Promise((resolve) => setTimeout(resolve, 50));
    }

    return false;
  }

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[href="#shop-pay-prequalify"]');
    if (!anchor) return;

    event.preventDefault();
    openShopPayPrequalFromAnchor(anchor);
  });
  } catch(e) { console.error(e); }
})();

})();
